// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__VbIcB","name":"Header_name__RxSHh","birthday":"Header_birthday__2P4Ur","skeleton":"Header_skeleton__EW6ej"};